export const PIRAEUS_CONSUMER_INTEREST = 10.95
export const PIRAEUS_CONSUMER_CONTRIBUTION = 0.6
export const PIRAEUS_CONSUMER_MAX_LOAN_AMOUNT = 15000
export const PIRAEUS_CONSUMER_MIN_LOAN_AMOUNT = 500

export const PIRAEUS_MORTGAGE_MAX_LOAN_AMOUNT = 2500000
export const PIRAEUS_MORTGAGE_MIN_LOAN_AMOUNT = 20000
export const PIRAEUS_MORTGAGE_FIXED_RATE_YEARS = [3, 5, 10, 15, 20, 25, 30]
export const PIRAEUS_MORTGAGE_CONTRIBUTION = 0.12
